import { Component, OnInit } from '@angular/core';
import { IMAGE, CATEGORY } from 'src/app/config';
import { ApiService } from 'src/app/api.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-category',
    templateUrl: './category.component.html',
    styleUrls: ['./category.component.css'],
    
})
export class CategoryComponent implements OnInit {
  slider_imgs = {};
  id:any;
  data: any;
  callshadow:any;
  img_url=IMAGE;
  Banner:any;
  constructor(private api: ApiService,private router:Router) { 
    
        this.api.Post(CATEGORY, {} ).then(data  => {
          this.data = data['data'];
  });
  }

  go(value){
      this.router.navigate(['subcategory', value]);
  }

  ngOnInit(): void {
  }

}
